const zh = {
	storeManagement: '门店管理',
	storeType: '门店类型',
	applicationStatus: '申请状态',
	storeStatus: '门店状态',
	storeCode: '门店编号',
	storeName: '门店名称',
	storeAddress: '门店地址',
	group: '群组',
	omniGroup: '所属群组',
	groupTip: '了解群组',
	addGroup: '创建群组',
	groupTipText: '群组管理可用于对贵司的区域、业务等进行权限隔离、对多网站/门店数据进行合并分析等，若不需要，则将使用默认群组管理。',
	applicationTime: '申请时间',
	withdrawAccount: '提现账户号',
	all: '全部',
	directStore: '直营店',
	franchiseStore: '加盟店',
	approved: '审核通过',
	decline: '已拒绝',
	pending: '审核中',
	modify: '审核不通过',
	noStoreAdded: '您尚未添加门店',
	realNameAuthFirst: '请先提交实名认证',
	submitRealNameAuthFirst: '您需要先提交实名认证，再添加门店',
	submitAuthMaterials: '提交实名材料',
	submitStoreInfo: '提交门店信息',
	storeDetails: '门店详情',
	addStore: '新增门店',
	fillLegalPerson: '请填写法人信息',
	fillBeneficiary: '请填写受益人信息',
	fillDirector: '请填写董事信息',
	basicInfo: '基本信息',
	storeInfo: '门店信息',
	directStoreType: '直营门店',
	franchiseStoreType: '加盟门店',
	storeNameEn: '门店名称（仅支持英文输入）',
	storePhone: '门店联系电话',
	businessLicenseNo: '门店营业执照编号',
	licenseEffectiveDate: '门店营业执照生效日期',
	licenseExpiryDate: '门店营业执照失效日期',
	businessRegistrationCertificate: '公司注册证书',
	hkBusinessLicenseNo: '商业登记号码(前8位)', // HK 修改
	hkBusinessRegistrationCertificate: '商业登记证', // HK 新增
	hkLicenseEffectiveDate: '商业登记证书生效日期', // HK 修改
	hkLicenseExpiryDate: '商业登记证书失效日期', // HK 修改
	hkRegistrationCertificate: '公司注册证书', // HK 新增
	hkRegistrationCertificateNo: '注册证书编号', // HK 新增
	hkCompanyEstablishedDate: '公司注册时间', // HK 新增
	hkAnnualReport: '法团成立表或周年申报表', // HK 新增,
	hkAnnualReportTips: '成立一年內可以提供NNC1（法团成立表格），一年以上要提供NAR1（周年申报表）', // HK 新增
	hkAddressProof: '地址证明', // 9231 HK新增
	hkBillOrcontract: '公司办公室租赁合同', // 9231 HK新增
	hkBankAccountInformation: '银行同名账户证明或基本存款账户信息', // 9231 HK新增
	hkBankAccountInformationTips: '请提供三个月内有效的银行证明', // 9231 HK新增
	companyRegisterCountry: '公司注册所在国家或地区',
	hkCompanyEnName: '公司英文名称',
	licenseImage: '门店营业执照影像',
	articlesOfAssociation: '公司章程（门店）',
	country: '国家',
	province: '省/州',
	city: '市',
	district: '区',
	addressEn: '详细地址（英文）',
	postcode: '门店邮编',
	relatedPersonnel: '相关人员信息',
	fillStoreLegalPerson: '请填写门店法人信息',
	addLegalPerson: '添加法人',
	fillStoreDirectorPerson: '请填写公司董事信息',
	addDirectorPerson: '添加董事',
	fillStoreBeneficiary: '请填写门店受益人信息',
	addBeneficiary: '添加受益人',
	otherMaterials: '其他材料',
	storePhotos: '门店照片',
	showStoreNumber: '需要显示门店门牌号',
	priceList: '价目表',
	consumptionPriceList: '门店消费价目表',
	warehousePhotos: '仓库照片',
	purchaseRecords: '采购记录',
	settlementAccount: '结算账户',
	settlementAccountType: '结算账户类型',
	distributionAccount: '分发账户',
	withdrawAccountNumber: '提现账户账号',
	storeLegalPerson: '门店法人',
	storeBeneficiary: '门店受益人',
	directorPerson: '门店董事',
	confirm: '确认',
	cancel: '取消',
	search: '查询',
	reset: '重置',
	addStoreBtn: '添加门店',
	operation: '操作',
	viewDetails: '查看详情',
	saveSuccess: '保存成功',
	required: '该字段为必填项',
	enNameRule: '请输入英文字符',
	emailRule: '邮箱格式不正确',
	account: {
		crzStoreType: '门店类型',
		crzCategory: '门店主营类目',
		crzUsage: '商业目的',
		crzEmail: '门店Email',
		partnershipDeedImage: '合伙人证明',
		shareStructureImage: '股权结构',
		legal: '法人',
		legal1: '门店经营人',
		storeBeneficiary: '门店受益人（股权≥25%）',
		storePartner: '门店合伙人',
		storeAgent: '代理人（选填）',
		addPartner: '添加合伙人',
		addAgent: '添加代理人',
		fillAgentPerson: '请填写代理人信息',
		fillPartner: '请填写合伙人信息',
		success: '提交成功',
		applyCrz: '申请分发账户',
		pending: '审核中',
		notActive: '（未激活）',
		active: '激活账户',
		needLiveness: '审核中，需人脸识别',
		liveness: '人脸识别',
		sole: '独资企业',
		partner: '合伙企业',
		company: '股份制企业',
		tip: '根据审核要求，请通过链接完成以下人员的人脸识别',
		reload: '刷新状态',
		copy: '复制',
		copied: '已复制到剪贴板',
		copyfailed: '复制失败，请稍后再试',
		incomplete: '未完成',
		failed: '失败',
		completed: '已完成',
		submit: '提交申请',
		policy1: '已阅读并同意',
		policy2: '处理和严格保密您的数据。'
	},
	phTaxCardNumber: '公司纳税识别号', // PH新增
	phTaxCardImg: '公司纳税卡证件（影像）', // PH新增
	companyRegisterCertificate: '公司注册证明', // 公司注册证明
	generalInfoTable: '通用信息表', // 公司基本信息表
	specialIndustryLicense: '特殊行业许可证', // 特殊行业许可证
	subMerchantInfoTable: '子商户信息表', // 子商户信息表,
	bankAccountInformation: '银行同名账户证明', // PH 新增
	registeredCapitalCertificate: '公司注册资金证明', // JP 新增
}

export default zh
